module.exports = __webpack_public_path__ + "static/img/5.95485ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/5.png
// module id = XG1p
// module chunks = 0